import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { of } from "rxjs";
import { Base64Utils } from "../utils/base64Utils";
import { API } from "../utils/constants";
import { CryptoUtils } from "../utils/cryptoUtils";
import { HandShakeConfig } from "../utils/handshake.config";
import { HandShake } from "../utils/handshake.model";
import { ConfigService } from "./config.service";

interface PageSession {
    ssId: string;
    pageKey: string;
}

// let cardProPageSession: PageSession = { ssId: null, pageKey: null };

@Injectable()
export class HandShakeService {

    private baseUrl: string;
    private sharedSecret: string;
    private sharedSecretBase64: string;
    private ssId: string;
    private isUsingBaseService: boolean;

    constructor(
        private http: HttpClient,
        private configService: ConfigService
    ) {
        this.baseUrl = this.configService.get(API);
    }

    // QuanTn
    async handShakeAllIn(data: object, usingBaseService = false) {
        this.isUsingBaseService = usingBaseService;
        let sharedSecret = "", sharedSecretBase64 = "";
        let cardProPageSession: PageSession = { ssId: null, pageKey: null };
        let doHandShake = async () => {
            if (
                !HandShakeConfig.handshakeForAllRequest &&
                cardProPageSession.ssId != null &&
                cardProPageSession.pageKey != null
            ) {
                sharedSecret = cardProPageSession.pageKey;
                sharedSecretBase64 = await CryptoUtils.toBase64(sharedSecret);
                return of(cardProPageSession.ssId);
            } else {
                sharedSecret = await CryptoUtils.randomKeyString(32);
                sharedSecretBase64 = await CryptoUtils.toBase64(sharedSecret);
                let pageJWK: any;

                return CryptoUtils.importKey(
                    JSON.stringify({
                        kty: "oct",
                        alg: "dir",
                        kid: sharedSecret,
                        k: sharedSecretBase64,
                        length: 256
                    }),
                    "json")
                    .then((jwk) => {
                        pageJWK = jwk;
                        return CryptoUtils.importKey(
                            HandShakeConfig.publicKey,
                            "pem"
                        )
                    })
                    .then(async (rsaKey) => {
                        let sharedSecrectBuffer = await CryptoUtils.toBufferFromBase64(
                            sharedSecretBase64
                        );
                        return CryptoUtils.encrypt(sharedSecrectBuffer, rsaKey);
                    })
                    .then((encryptedContent) => {
                        let handShakeDto = new HandShake();
                        handShakeDto.key = encryptedContent;

                        return this.http.post(
                            this.isUsingBaseService
                                ? this.baseUrl + HandShakeConfig.handshakeBaseUrl
                                : this.baseUrl + HandShakeConfig.handshakeUrl,
                            handShakeDto
                        ).toPromise()
                    })
                    .then((response: any) =>
                        this.doChallengeEdit(response, pageJWK, sharedSecret)
                    );
            }
        }

        return await doHandShake().then((ssid) => {
            // this.ssId = ssid;
            return CryptoUtils.importKey(
                JSON.stringify({
                    kty: "oct",
                    alg: "A256GCM",
                    kid: sharedSecret,
                    use: "enc",
                    k: sharedSecretBase64,
                    length: 256
                }),
                "json"
            )
                .then(async (pageJWK) => {
                    let base64EncodedData = await Base64Utils.encode(
                        JSON.stringify(data)
                    );

                    return CryptoUtils.encrypt(
                        base64EncodedData,
                        pageJWK
                    )
                })
                .then((result) => {
                    cardProPageSession.ssId = ssid;
                    cardProPageSession.pageKey = sharedSecret;
                    return { data: result, ssId: ssid };
                })
        });
    }

    // handShake(data: object, usingBaseService = false) {
    //     this.isUsingBaseService = usingBaseService;
    //     return this.doHandShake().pipe(
    //         mergeMap((ssid) => {
    //             this.ssId = ssid;
    //             console.log("HANDSHAKE START", this.sharedSecret)
    //             console.log("HANDSHAKE START 64", this.sharedSecretBase64)
    //             return CryptoUtils.importKey(
    //                 JSON.stringify({
    //                     kty: "oct",
    //                     alg: "A256GCM",
    //                     kid: this.sharedSecret,
    //                     use: "enc",
    //                     k: this.sharedSecretBase64,
    //                     length: 256
    //                 }),
    //                 "json"
    //             )
    //                 .pipe(
    //                     mergeMap((pageJWK) => {
    //                         let base64EncodedData = Base64Utils.encode(
    //                             JSON.stringify(data)
    //                         );

    //                         return CryptoUtils.encrypt(
    //                             base64EncodedData,
    //                             pageJWK
    //                         )
    //                     })
    //                 )
    //                 .pipe(
    //                     map((result) => {
    //                         cardProPageSession.ssId = this.ssId;
    //                         cardProPageSession.pageKey = this.sharedSecret;
    //                         return { data: result, ssId: this.ssId };
    //                     })
    //                 );
    //         })
    //     );
    // }

    // private doHandShake(): Observable<string> {
    //     if (
    //         !HandShakeConfig.handshakeForAllRequest &&
    //         cardProPageSession.ssId != null &&
    //         cardProPageSession.pageKey != null
    //     ) {
    //         this.sharedSecret = cardProPageSession.pageKey;
    //         this.sharedSecretBase64 = CryptoUtils.toBase64(this.sharedSecret);
    //         return of(cardProPageSession.ssId);
    //     } else {
    //         this.sharedSecret = CryptoUtils.randomKeyString(32);
    //         this.sharedSecretBase64 = CryptoUtils.toBase64(this.sharedSecret);
    //         console.log(this.sharedSecretBase64);
    //         let pageJWK: any;

    //         return CryptoUtils.importKey(
    //             JSON.stringify({
    //                 kty: "oct",
    //                 alg: "dir",
    //                 kid: this.sharedSecret,
    //                 k: this.sharedSecretBase64,
    //                 length: 256
    //             }),
    //             "json"
    //         )
    //             .pipe(
    //                 mergeMap((jwk) => {
    //                     pageJWK = jwk;
    //                     return CryptoUtils.importKey(
    //                         HandShakeConfig.publicKey,
    //                         "pem"
    //                     )
    //                 })
    //             )
    //             .pipe(
    //                 mergeMap((rsaKey) => {
    //                     let sharedSecrectBuffer = CryptoUtils.toBufferFromBase64(
    //                         this.sharedSecretBase64
    //                     );
    //                     console.log(sharedSecrectBuffer);
    //                     console.log("Crypt",this.sharedSecretBase64);
    //                     return CryptoUtils.encrypt(sharedSecrectBuffer, rsaKey);
    //                 })
    //             )
    //             .pipe(
    //                 mergeMap((encryptedContent) => {
    //                     let handShakeDto = new HandShake();
    //                     handShakeDto.key = encryptedContent;

    //                     return this.http.post(
    //                         this.isUsingBaseService
    //                             ? this.baseUrl +
    //                             HandShakeConfig.handshakeBaseUrl
    //                             : this.baseUrl + HandShakeConfig.handshakeUrl,
    //                         handShakeDto
    //                     )
    //                 })
    //             )
    //             .pipe(
    //                 mergeMap((response: any) =>
    //                     this.doChallenge(response, pageJWK)
    //                 )
    //             );
    //     }
    // }

    // private doChallenge(dto: HandShake, pageJWK) {
    //     return CryptoUtils.decryptFromKeyStore(dto.challenge, pageJWK).pipe(
    //         map((result) => {
    //             let decryptedKey = result.plaintext.toString();
    //             if (decryptedKey !== this.sharedSecret) {
    //                 throw new Error("handshake failed");
    //             }
    //             return dto.key;
    //         })
    //     )
    // }

    private doChallengeEdit(dto: HandShake, pageJWK, sharedSecret) {
        return CryptoUtils.decryptFromKeyStore(dto.challenge, pageJWK).then(
            (result) => {
                let decryptedKey = result.plaintext.toString();
                if (decryptedKey !== sharedSecret) {
                    throw new Error("handshake failed");
                }
                return dto.key;
            })
    }
}